import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { Check, X } from 'lucide-react';
export function WhoIsThisFor() {
  const forYou = ['Madres que trabajan full-time y sienten que el agotamiento está afectando su desempeño laboral.', "Mujeres en posiciones de liderazgo o alta responsabilidad que no pueden permitirse 'neblina mental'.", 'Madres que regresan de su licencia de maternidad y están a punto de colapsar.', 'Cualquier madre que necesite un plan logístico, no solo consejos sentimentales.'];
  const notForYou = ["Personas que prefieren métodos de 'llanto libre' extremo durante horas.", 'Padres que no tienen una estructura de horario mínima durante el día.', 'Quienes buscan una solución mágica que no requiera aplicar cambios consistentes en el ambiente.'];
  return <div className="bg-cream-dark text-navy border-y border-navy/5" data-id="element-224">
      <SectionWrapper data-id="element-225">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 max-w-5xl mx-auto" data-id="element-226">
          {/* For You */}
          <div className="bg-white p-8 md:p-10 rounded-sm shadow-sm border-t-4 border-green-600" data-id="element-227">
            <h3 className="text-2xl font-serif mb-8 text-center" data-id="element-228">
              Este protocolo{' '}
              <span className="font-bold italic" data-id="element-229">es para ti</span> si...
            </h3>
            <ul className="space-y-6" data-id="element-230">
              {forYou.map((item, index) => <li key={index} className="flex items-start" data-id="element-231">
                  <Check className="text-green-600 shrink-0 mt-1 mr-4" size={24} data-id="element-232" />
                  <span className="font-sans text-navy/80 leading-relaxed" data-id="element-233">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>

          {/* Not For You */}
          <div className="bg-white p-8 md:p-10 rounded-sm shadow-sm border-t-4 border-red-800" data-id="element-234">
            <h3 className="text-2xl font-serif mb-8 text-center" data-id="element-235">
              Este protocolo{' '}
              <span className="font-bold italic" data-id="element-236">NO es para ti</span> si...
            </h3>
            <ul className="space-y-6" data-id="element-237">
              {notForYou.map((item, index) => <li key={index} className="flex items-start" data-id="element-238">
                  <X className="text-red-800 shrink-0 mt-1 mr-4" size={24} data-id="element-239" />
                  <span className="font-sans text-navy/80 leading-relaxed" data-id="element-240">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>
      </SectionWrapper>
    </div>;
}